import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";

function ToastError(props) {
  const handleClose = () => {
    props.closeToast();
  };

  return (
    <>
      {props.show ? (
        <ToastContainer className='p-3'>
          <Toast onClose={() => handleClose()} bg='danger'>
            <Toast.Header>
              <strong className='me-auto'> {props.title ? props.title : "Erro ocorrido"}</strong>
            </Toast.Header>
            <Toast.Body>
              {props.text ? props.text : "Ocorreu um erro no processo. Visualize logs do navegador para mais detalhes."}
            </Toast.Body>
          </Toast>
        </ToastContainer>
      ) : null}
    </>
  );
}

export default ToastError;
